/**
 * The further below an enum entry is, the higher its index-z value
 *
 * @NOTE: Do not modify legacy values unless they are also modified in legacy code
 */
export enum Z_INDEXES {
  LEGACY_SWIPER_NOTIFICATION = -1000,
  LEGACY_ANIMATED_MODAL_OVERLAY = -999,
  IP_POPUP_IMAGE = -1,
  CATEGORY_TREE_BACKGROUND = -1,
  ZERO = 0,
  ONE = 1,
  LEGACY_LANE_SCROLLER = 1,
  LEGACY_PAGE_SECTION = 1,
  TADARIDA_HEADER_NAVIGATION_BUTTONS = 1,
  TADARIDA_HEADER_IMG_TEASER_TEXTLINE = 1,
  TADARIDA_BRANDS_HUB_HEADER_NAVIGATION_BUTTONS = 1,
  PRODUCT_SLIDER_BADGES_CONTAINER = 2,
  TADARIDA_HEADER_IMG_TEASER_CTA = 2,
  LEGACY_SEARCH_INPUT = 2,
  SIZE_CHART_MODAL_HEADER = 2,
  PERSONALIZED_FILTERS_HINT = 2,
  ADP_BUYBOX = 1,
  ADP_QUICKVIEW_HANDLER_CLOSE_BTN = 1,
  PRODUCT_TILE_SUSTAINABILITY_ICON = 1,
  TADARIDA_FULLSCREEN_SLIDER_CLOSE_BTN = 1,
  FLYOUT_STICKY_HEADER = 2,
  APP_SCROLL_TO_TOP = 2,
  ADP_STICKY_A2B_BUTTON_CONTAINER = 2,
  ADP_COUNTDOWN = 2,
  TOGGLE_BAR = 2,
  TOGGLE_INPUT = 3,
  ADP_BACK_BUTTON = 3,
  LEGACY_HERO_TEXT = 3,
  ADP_MWEB_COUPON_SLIDER = 4,
  ADP_CAMPAIGN_BANNER = 4,
  APP_INSTALL_TEASER_CONTAINER = 4,
  ADD_TO_BASKET_FLYOUT_CTA_WRAPPER = 5,
  LEGACY_SWITCH_PROMPT_WRAPPER = 5,
  LEGACY_FLOATING_ACTION_BUTTOn = 5,
  LEGACY_PAGE_HEADER_HEADER_CONTENT = 10,
  LEGACY_ADP_SLIDER_BADGES_CONTAINER = 20,
  LEGACY_ADP_SLIDER_SHARE_BUTTON_CONTAINER = 20,
  SUB_HEADER = 21,
  ADP_QUICK_VIEW_POPUP = 21,
  CATEGORY_TREE = 22,
  SEARCH_RESULTS_QUESTIONNAIRE = 22,
  COUPON_LANDING_PAGE_HEADER = 23,
  SLIDE_IN_CONTAINER = 23,
  ADP_QUICK_VIEW_POPUP_ON_TOP = 100,
  GENERIC_FLYOUT = 101,
  NOTIFICATION_CENTER_FLYOUT = 102,
  ADP_QUICK_VIEW_POPUP_ON_TOP_FLYOUT = 101,
  APP_INSTALL_BANNER = 22,
  SIMPLE_BANNER = 22,
  MAIN_HEADER = 22,
  DESKTOP_HEADER = 100,
  TADARIDA_FULLSCREEN_SLIDER_WRAPPER = 22,
  FILTER_ONBOARDING_BG = 97,
  FILTER_ONBOARDING_CONTENT = 98,
  LEGACY_PAGE_HEADER_ICONS_PLACEMENT_CONTAINER = 99,
  OSP_ROKT_LOADER = 99,
  LEGACY_OVERLAY = 99,
  DISCOUNT_BANNER = 100,
  FLYOUT_FADE = 101,
  OFF_CANVAS = 101,
  DRAWER = 102,
  FILTER_DROPDOWN = 99,
  LEGACY_MODAL_BODY_CONTENT = 100,
  LEGACY_MODAL_CONTAINER = 100,
  LEGACY_CRAZY_CAMPAIN_DIALOG = 100,
  HEADER_COUNTRY_SWITCH_POPUP = 101,
  ADP_QUICK_VIEW_WRAPPER = 200,
  LEGACY_LOGIN_TEASER_TOAST = 300,
  TOAST_NOTIFICATION = 300,
  MODAL_DIALOG_WRAPPER = 999,
  TADARIDA_HEADER_NAVIGATION_CONTENT = 999,
  FLYOUT_FADE_ON_DRAWER = 1000,
  MOV_BASKET_FLYOUT_INFO_MODAL = 1000,
  TADARIDA_BASKET_FLYOUT = 1000,
  TADARIDA_TOAST_CONTAINER = 1000,
  TADARIDA_HEADER_NAVIGATION_ARROW = 1000,
  LANGUAGE_SWITCH_POPUP = 1000,
  SHOP_HINT = 1000,
  SUSTAINABILITY_MODAL_DIALOG = 1001,
  TADARIDA_HEADER_ICON_META_NAVIGATION_CONTENT = 1001,
  TADARIDA_HEADER_ICON_META_NAVIGATION_ARROW = 1002,
  TADARIDA_HEADER_SEARCH_RESULTS = 1003,
  HEADER_DISCOUNT_POPUP = 1004,
  TADARIDA_HEADER_LANGUAGE_SWITCH_POPUP = 1004,
  TADARIDA_HEADER_LANGUAGE_SWITCH_POPUP_ARROW = 1005,
  TADARIDA_HEADER_ICON_META_FLYOUTS = 1004,
  AVAILABLE_COUNTRY_SWITCH_BOTTOM_SHEET = 1299,
  LEGACY_ANIMATED_TOAST = 1900,
  LEGACY_OFFLINE_CONTAINER = 9999,
  LEGACY_BASKET_LOADING_MODAL_CONTAINER = 9999,
  MODAL_DIALOG_CLOSE_BUTTON = 9999,
}
